import { createAction, props } from '@ngrx/store';

export const getCRMOffersApi = createAction(
  '[CRM Component API] Load CRM Offers'
);

export const getCRMOffersSuccess = createAction(
  '[CRM Component] Load CRM Offers Success',
  props<{ offers: any | null }>()
);

export const getCRMOffersFailure = createAction(
  '[CRM Component] Load CRM Offers Failure',
  props<{ error: any }>()
);

export const selectActiveCRMOffer = createAction(
  '[CRM Component API] Select CRM Offer',
  props<{ selectedCRMOffer: any }>()
);

export const countCRMOffersApi = createAction(
  '[Count CRM Component API] Count CRM Offers'
);

// export const countCRMOffersSuccess = createAction(
//   '[Count CRM Component API] Count CRM Offers Success',
//   props<{ countOffers: any | null }>()
// );

// export const countCRMOffersFailure = createAction(
//   '[CRM] Count CRM Offers Failure',
//   props<{ error: any }>()
// );
export const countCRMOffersSuccess = createAction(
  '[CRM] Count CRM Offers Success',
  props<{ count: number }>()
);
export const countCRMOffersFailure = createAction(
  '[CRM] Count CRM Offers Failure',
  props<{ error: any }>()
);
